import { Twenty47RequestEntity } from "../../entities/service-book/twenty47-request";

export class Twenty47RequestCreateRequest {
   Twenty47RequestEntity: Twenty47RequestEntity;
}